import home from './home'
import product from './product'
import solution from './solution'
import technology from './technology'
import buy from './buy'
import smartApps from './smart-apps'
import cloudNative from './cloud-native'
import digitalThread from './digital-thread'
import edgeComputing from './edge-computing'
import twin from './twin'
import whyJWI from './why-jwi'
import history from './history'
import careers from './careers'
import industry from './industry'
import analytics from './analytics'
import iot from './iot'
import cloudPlatform from './cloud-platform'
import digitalPdm from './digital-pdm'
import digitalNpi from './digital-npi'
import digitalPpm from './digital-ppm'
import digitalMpm from './digital-mpm'
import digitalPqm from './digital-pqm'
import navigation from './navigation'
import deviceMate from './device-mate'
import productLine from './product-line'

const common = {
  website: '杰为软件系统（深圳）有限公司',
  // 头部导航
  home: '首页',
  login: '登录',
  contactUs: '联系我们',
  products: '产品',
  platform: '数字化平台',
  jicCloud: '实时数字化链平台',
  devopsCloud: '开发云平台',
  engineering: '数字化工程',
  navigator: '设计导航',
  pdm: '数字化PDM',
  ppm: '投资组合管理',
  mpm: '数字化工艺',
  npi: '数字化NPI',
  factory: '数字化工厂',
  pqm: '质量云-制程质量管理',
  deviceMate: '设备数字孪生',
  productionLineEngine: '数字产线引擎',
  solutions: '解决方案',
  technology: '技术',
  cloudNative: '云原生',
  digitalThread: '实时数字化链',
  smartApps: '智能应用',
  edgeComputing: '边缘计算',
  twin: '数字孪生',
  analytics: '高级分析',
  iot: '工业物联网',
  company: '公司',
  whyJwi: '选择杰为',
  history: '历史',
  careers: '加入我们',
  trybuy: '试用&购买',
  jwisoftware: '杰为软件',
  btnCancel: '取消',
  btnConfirm: '确定'
}

export default Object.assign(home, product, solution, technology, buy, smartApps, cloudNative, digitalThread, edgeComputing, twin, whyJWI, history, careers, industry, analytics, iot, cloudPlatform, digitalPdm, digitalNpi, digitalPpm, digitalMpm, digitalPqm, navigation, deviceMate, productLine, common)
